// ../Dialog/DesconfirmarTrasladoDialog.js
import React from "react";
import PropTypes from "prop-types";
import { Modal, Typography, Space, Divider, Button, Card } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

// Componente DesconfirmarTrasladoDialog para desconfirmar un traslado
function DesconfirmarTrasladoDialog({
  open,
  onClose,
  onDesconfirmar,
  trasladoId,
}) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <Space align="center">
          <CloseCircleOutlined style={{ fontSize: "24px", color: "#ff4d4f" }} />
          <Title level={5} style={{ margin: 0 }}>
            Desconfirmar Traslado
          </Title>
        </Space>
      }
      width={600}
      centered
      destroyOnHidden
    >
      <Card
        variant="borderless"
        style={{
          backgroundColor: "#fafafa",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          padding: "24px",
        }}
      >
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          {/* Información del Traslado */}
          <div>
            <Text type="secondary">
              Vas a desconfirmar el traslado con el siguiente{" "}
              <strong>CS-ID:</strong>
            </Text>
            <Title
              level={3}
              style={{
                backgroundColor: "#fff1f0",
                padding: "12px",
                borderRadius: "8px",
                textAlign: "center",
                color: "#ff4d4f",
                marginTop: "8px",
              }}
            >
              {trasladoId || "CS-ID no disponible"}
            </Title>
          </div>
          <Divider />

          {/* Confirmación de Desconfirmación */}
          <Space align="center">
            <CloseCircleOutlined
              style={{ fontSize: "20px", color: "#ff4d4f" }}
            />
            <Text>
              ¿Estás seguro de que deseas desconfirmar este traslado? Esta
              acción revertirá su estado a "Sin Confirmar".
            </Text>
          </Space>
        </Space>
        <Divider />
        {/* Acciones */}
        <Space
          style={{ display: "flex", justifyContent: "flex-end" }}
          size="middle"
        >
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            type="primary"
            onClick={onDesconfirmar}
            danger
            icon={<CloseCircleOutlined />}
          >
            Desconfirmar
          </Button>
        </Space>
      </Card>
    </Modal>
  );
}

// **Validación de las props con PropTypes**
DesconfirmarTrasladoDialog.propTypes = {
  open: PropTypes.bool.isRequired, // Booleano que indica si el diálogo está abierto
  onClose: PropTypes.func.isRequired, // Función para cerrar el diálogo
  onDesconfirmar: PropTypes.func.isRequired, // Función para desconfirmar el traslado
  trasladoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DesconfirmarTrasladoDialog;
